import BaseErrorPage from 'components/BaseErrorPage';

const ErrorPage = () => (
  <BaseErrorPage title="That's unexpected!">
    We’re aware that something isn’t quite right and we’re in the middle of fixing it. <br />
    Try refreshing the page or come back again later.
  </BaseErrorPage>
);

export default ErrorPage;
